import { render, staticRenderFns } from "./clientFundDetailExchange.vue?vue&type=template&id=cd1798d4&scoped=true"
import script from "./clientFundDetailExchange.vue?vue&type=script&lang=js"
export * from "./clientFundDetailExchange.vue?vue&type=script&lang=js"
import style0 from "./clientFundDetailExchange.vue?vue&type=style&index=0&id=cd1798d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1798d4",
  null
  
)

export default component.exports